import { useEffect, useState } from 'react';
import { useMatches } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { PUBLIC_ROUTES_SECTION_ID } from '../../constants/app';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { isPublicPageState, pageState, sidenavIsPinnedState } from '../../storage/app';

export function AppProvider() {
  const { isSmall } = useBreakpoints();
  const setSidenavIsPinned = useSetRecoilState(sidenavIsPinnedState);
  const setPage = useSetRecoilState(pageState);
  const setIsPublicPage = useSetRecoilState(isPublicPageState);
  const [isInitialLoad, setInitialLoad] = useState(true);
  const matches = useMatches();

  useEffect(() => {
    if (isInitialLoad) {
      setInitialLoad(false);
      return;
    }
    if (isSmall) {
      setSidenavIsPinned(false);
    }
  }, [isSmall]);

  useEffect(() => {
    if (matches.length) {
      setIsPublicPage(matches[0].id === PUBLIC_ROUTES_SECTION_ID);
      setPage(matches[matches.length - 1].id);
    } else {
      setPage('');
    }
  }, [matches]);

  return null;
}
